export default __webpack_public_path__ + "static/media/smileman.7a10260a.png";